import { render, staticRenderFns } from "./inside.vue?vue&type=template&id=50a8881c&functional=true"
import script from "./inside.vue?vue&type=script&lang=js"
export * from "./inside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports